import Role from "../../models/Role";

const getPopAppRole = (roles: string[]) =>
  roles!
    .filter((role) => role.includes("pop"))
    .map((role) => role.split("_")[2] as Role) ?? [];

export default getPopAppRole;
